/* One controller for native Shopify contacts/newsletter and the quiz.
 * No direct Sheets/Klaviyo writes. Native success is rendered by Liquid.
 */
(function () {
  'use strict';
  if (window.PetspemfForms) return;
  var cfg = window.PetspemfFormsConfig || {};
  var api = 'https://app.petspemf.com/api/forms/';
  var storeKey = 'petspemf.forms.v2';
  var active = new WeakMap();
  var nativePass = new WeakSet();
  var deliveries = new Map();
  var pending;
  try { pending = JSON.parse(sessionStorage.getItem(storeKey) || '{}'); } catch (_) { pending = {}; }
  function persist() { try { sessionStorage.setItem(storeKey, JSON.stringify(pending)); } catch (_) { /* native works; current page retains state */ } }
  function canonical(fields) { return JSON.stringify(Object.keys(fields).sort().map(function (k) { return [k, fields[k]]; })); }
  function message(form, text) {
    var node = form.querySelector('[data-petspemf-form-status]');
    if (!node) { node = document.createElement('p'); node.setAttribute('data-petspemf-form-status', ''); node.setAttribute('role', 'status'); form.appendChild(node); }
    node.textContent = text;
  }
  function busy(form, value) {
    form.setAttribute('aria-busy', value ? 'true' : 'false');
    form.querySelectorAll('button[type="submit"],input[type="submit"]').forEach(function (b) { b.disabled = value; });
  }
  function installHoneypot(form) {
    if (form.querySelector('[data-petspemf-honeypot]')) return;
    var label = document.createElement('label');
    label.setAttribute('aria-hidden', 'true');
    label.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden';
    label.textContent = 'Leave this field empty';
    var field = document.createElement('input');
    field.type = 'text'; field.name = 'website_check'; field.tabIndex = -1; field.autocomplete = 'off'; field.setAttribute('data-petspemf-honeypot', '');
    label.appendChild(field); form.appendChild(label);
  }
  var loading;
  function turnstileReady() {
    if (window.turnstile) return Promise.resolve();
    if (!loading) loading = new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error('verification_unavailable')); }, 15000);
      var script = document.createElement('script'); script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; script.async = true;
      script.onload = function () { clearTimeout(timer); resolve(); };
      script.onerror = function () { clearTimeout(timer); loading = null; reject(new Error('verification_unavailable')); };
      document.head.appendChild(script);
    });
    return loading;
  }
  async function challenge(form, kind, id) {
    if (!cfg.sitekey) throw new Error('verification_unavailable');
    await turnstileReady();
    return new Promise(function (resolve, reject) {
      var container = document.createElement('div'); form.appendChild(container);
      var widget, timer, finished = false;
      function finish(error, token) {
        if (finished) return; finished = true; clearTimeout(timer);
        // Callback may run immediately with a cached challenge.
        setTimeout(function () { if (widget !== undefined) window.turnstile.remove(widget); container.remove(); }, 0);
        error ? reject(new Error(error)) : resolve(token);
      }
      timer = setTimeout(function () { finish('verification_expired'); }, 240000);
      widget = window.turnstile.render(container, { sitekey: cfg.sitekey, action: kind, cData: id, theme: 'light',
        callback: function (token) { finish(null, token); },
        'error-callback': function () { finish('verification_failed'); },
        'expired-callback': function () { finish('verification_expired'); },
      });
    });
  }
  async function post(stage, value) {
    var controller = new AbortController(); var timeout = setTimeout(function () { controller.abort(); }, 20000);
    try {
      var response = await fetch(api + stage, { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(value), signal: controller.signal });
      var result = await response.json();
      if (!response.ok) throw new Error(result.error || 'temporarily_unavailable');
      return result;
    } finally { clearTimeout(timeout); }
  }
  async function prepare(form, kind, fields, consent, key) {
    var hp = form.querySelector('[data-petspemf-honeypot]');
    if (hp && hp.value) throw new Error('invalid_fields');
    var fingerprint = canonical(fields) + ':' + consent;
    var entry = pending[key];
    if (!entry || entry.fingerprint !== fingerprint || entry.kind !== kind || (entry.accepted && Date.now()-entry.created > 300000)) {
      entry = { kind: kind, fingerprint: fingerprint, created: Date.now(), payload: { submission_id: crypto.randomUUID(), form: kind, fields: fields, consent: consent, website_check: '' } };
      pending[key] = entry; persist();
    }
    if (!entry.receipt || entry.expires < Date.now()) {
      entry.confirmed = false;
      var token = await challenge(form, kind, entry.payload.submission_id);
      var result = await post('prepare', { payload: entry.payload, token: token });
      entry.receipt = result.receipt; entry.expires = Date.now() + 29 * 60000; persist();
    }
    return entry;
  }
  async function submit(entry) {
    if (entry.accepted) return;
    var id = entry.payload.submission_id;
    if (deliveries.has(id)) return deliveries.get(id);
    var work = (async function () {
      try {
        var result = await post('submit', { payload: entry.payload, receipt: entry.receipt });
        if (!result.accepted) throw new Error('not_accepted');
        entry.accepted = true; entry.payload.fields = {}; persist();
      } finally { deliveries.delete(id); }
    })();
    deliveries.set(id, work); return work;
  }
  function nativeFields(form, kind) {
    if (kind === 'newsletter') return { Email: (form.elements['contact[email]'].value || '').trim(), Source: 'Footer newsletter' };
    var fields = {};
    Array.from(form.elements).forEach(function (el) { var m = /^contact\[(.+)\]$/.exec(el.name || ''); if (m && el.type !== 'submit') fields[m[1]] = String(el.value || '').trim(); });
    return fields;
  }
  function nativeFallback(form) {
    if (form.querySelector('[data-petspemf-fallback]')) return;
    var b = document.createElement('button'); b.type = 'button'; b.textContent = 'Send using our standard form'; b.setAttribute('data-petspemf-fallback', '');
    b.onclick = function () { nativePass.add(form); form.requestSubmit(); };
    form.appendChild(b);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-petspemf-form]')) return;
    if (nativePass.has(form)) { nativePass.delete(form); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    if (active.has(form)) return;
    // A success marker from a PREVIOUS native submission cannot confirm this one.
    form.querySelectorAll('[data-petspemf-native-success]').forEach(function (node) { node.removeAttribute('data-petspemf-native-success'); });
    var kind = form.dataset.petspemfForm, key = kind + ':' + form.id;
    busy(form, true); message(form, 'Verifying your submission…');
    var fields = nativeFields(form, kind);
    var work = prepare(form, kind, fields, kind === 'newsletter' || kind === 'veterinary', key).then(function () {
      if (canonical(fields) !== canonical(nativeFields(form, kind))) throw new Error('fields_changed');
      busy(form, false); message(form, 'Sending…'); nativePass.add(form); form.requestSubmit();
    }).catch(function (error) {
      busy(form, false); message(form, 'We could not verify or send this yet. Your details are still here. Please try again.');
      if (['temporarily_unavailable', 'verification_unavailable', 'Failed to fetch'].includes(error.message) || error.name === 'AbortError') nativeFallback(form);
    }).finally(function () { active.delete(form); });
    active.set(form, work);
  }, true);
  async function confirmNative(form) {
    var key = form.dataset.petspemfForm + ':' + form.id, entry = pending[key];
    // Marker exists only in Liquid form.posted_successfully?. URL is never proof.
    if (!entry || !entry.receipt || entry.accepted || !form.querySelector('[data-petspemf-native-success]')) return;
    entry.confirmed = true; persist();
    try { await submit(entry); }
    catch (_) {
      message(form, 'Your message was received by our store. The additional confirmation is pending.');
      setTimeout(function () { if (entry.expires > Date.now()) confirmNative(form); }, 15000);
    }
  }
  function init(scope) {
    Object.keys(pending).forEach(function (key) {
      var entry = pending[key];
      if (Date.now() - entry.created > 86400000) { delete pending[key]; persist(); return; }
      if (entry.confirmed && !entry.accepted && entry.expires > Date.now()) submit(entry).catch(function () {});
    });
    (scope || document).querySelectorAll('form[data-petspemf-form],[data-quiz-form]').forEach(function (form) { installHoneypot(form); if(form.dataset.petspemfForm) confirmNative(form); });
  }
  window.PetspemfForms = {
    init: init,
    quiz: async function (form, fields, consent) {
      if (active.has(form)) return active.get(form);
      installHoneypot(form); busy(form, true);
      var work = (async function () {
        try { var entry = await prepare(form, 'quiz', fields, consent, 'quiz'); await submit(entry); }
        finally { busy(form, false); active.delete(form); }
      })();
      active.set(form, work); return work;
    },
  };
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('pageshow', function () { document.querySelectorAll('form[data-petspemf-form]').forEach(function (f) { busy(f, false); }); init(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
})();
